import {createStore} from "vuex";
import loading from "./modules/loading";
import session from "./modules/session"
import workspaces from "./modules/workspaces"
import infoModal from "./modules/infoModal"
import diamonds from "./modules/diamonds"

export default createStore({
    modules: {
        loading,
        session,
        workspaces,
        infoModal,
        diamonds
    },
});
